<template>
  <nav v-if="content.menu?.[0]" ref="facilityBar" role="navigation" aria-label="Facility menu" class="facility-bar">
    <SimpleButton v-if="!isDesktop" class="open-button hidden-tablet" :title="useMicroCopy('facilitybar.expandbutton.label')"
      :aria-expanded="isExpanded" aria-controls="facility-bar-panel" solid @click="openModal">
      {{ useMicroCopy("facilitybar.expandbutton.text") }}
    </SimpleButton>

    <div v-if="isDesktop" class="desktop-menu-wrapper">
      <FacilityBarMenu :content="content" :formattedPhoneNumber="formattedPhoneNumber"
        :callCenterPhoneNumber="callCenterPhoneNumber" :isPublicGestionType="isPublicGestionType"
        :isExpanded="isExpanded" :tracking="tracking" />
    </div>

    <GenericModal ref="modal" height-auto @close="onCloseModal">
      <FacilityBarMenu :content="content" :formattedPhoneNumber="formattedPhoneNumber"
        :callCenterPhoneNumber="callCenterPhoneNumber" :isPublicGestionType="isPublicGestionType"
        :isExpanded="isExpanded" :tracking="tracking" />
    </GenericModal>
  </nav>
</template>

<script setup>
import GenericModal from '@/components/GenericModal.vue'
import FacilityBarMenu from '@/components/FacilityBarMenu.vue'

const props = defineProps({ content: Object, required: true })
const { content } = toRefs(props)
const { isDesktop } = useDevice()
const isExpanded = ref(false)
const facilityBar = ref(null)

let facilityTypeGroupKey
let callCenterPhoneNumber
if (content?.value?.facilityTypeGroupKey) {
  facilityTypeGroupKey = content.value.facilityTypeGroupKey
  callCenterPhoneNumber = usePhoneByFacityType(facilityTypeGroupKey)
}

let formattedPhoneNumber = ""
if (typeof useMicroCopy('phone.prefix') === 'string' && typeof callCenterPhoneNumber === 'string') {
  formattedPhoneNumber = useFormattedPhone(useMicroCopy('phone.prefix'), callCenterPhoneNumber)
} else if (typeof content.value.prefix === 'string' && typeof content.value.phoneNumber === 'string') {
  formattedPhoneNumber = useFormattedPhone(content.value.prefix, content.value.phoneNumber)
}

const isPublicGestionType = false

const modal = ref(null)
const openModal = () => { isExpanded.value = true; modal?.value?.openModal?.() }
const onCloseModal = () => { isExpanded.value = false }

useResizeObserver(facilityBar, () => { if (isDesktop.value) isExpanded.value = false })

const trackingStore = useTrackingStore()
const tracking = (data) => { trackingStore.sendTrackingData(data) }
</script>

<style lang="scss" scoped>
.facility-bar {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  z-index: $z-index-fixed;
  margin: 0.25rem auto;
  width: 95.5%;
  max-width: $header-width;

  @include for-tablet-landscape-up {
    position: sticky;
    top: 5.25rem;
    bottom: auto;
    left: 0;
    transform: none;
    margin: 1.25rem auto;
  }

  .desktop-menu-wrapper {
    display: block;

    @include for-phone-only {
      display: none;
    }
  }

  .hidden-tablet{
    display: none;

    @include for-phone-only {
      display: block;
    }
  }

  .open-button {
    width: 100%;
  }
}
</style>